import {SabrPurchaseOrder} from './sabr-purchase-order';
import {SabrRelease} from './sabr-release';
import {SabrInvoice} from './sabr-invoice';

export class SabrSummary {
  project: SabrPurchaseOrder = new SabrPurchaseOrder();
  releases: SabrRelease[] = [];
  invoices: SabrInvoice[] = [];
  unreleasedQuantity!: number;
  unreleasedAmount!: number;
  releasedInProcessQuantity!: number;
  releasedInProcessAmount!: number;
  releasedShippedQuantity!: number;
  releasedShippedAmount!: number;
}
